import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"color":"#4d4d4d","font-weight":"400","font-size":"14px"} }
const _hoisted_3 = { style: {"font-size":"12px","color":"rgba(113, 113, 113, 1)"} }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { style: {"color":"#4d4d4d","font-weight":"400","font-size":"14px"} }
const _hoisted_7 = { style: {"font-size":"12px","color":"rgba(113, 113, 113, 1)"} }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = {
  key: 4,
  style: {"font-size":"12px","color":"rgba(113, 113, 113, 1)"}
}
const _hoisted_10 = { key: 5 }
const _hoisted_11 = { key: 6 }
const _hoisted_12 = { key: 7 }
const _hoisted_13 = { key: 8 }
const _hoisted_14 = { key: 9 }
const _hoisted_15 = { key: 10 }
const _hoisted_16 = { key: 11 }

import moment from "moment";
import { useStore } from "@/store";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeShow',
  props: {
    dateIsoString: {},
    format: {},
    type: {}
  },
  setup(__props: any) {

const props = __props;



const store = useStore();

const date = computed(() => {
  // const regex = /\.\d+Z$/;
  // let str = props.dateIsoString;
  // console.log(str);
  // if (regex.test(str)) {
  //   str = str.slice(0, -5);
  //   console.log(str);
  // }
  // return moment(str).locale(store.state.AuthModule.user.language);
  // return moment(props.dateIsoString).locale(
  //   store.state.AuthModule.user.language
  // );
  return moment(props.dateIsoString);
});

const getExactDateAndTime = () => {
  const date = moment.parseZone(props.dateIsoString);
  const formattedDate = date.format("YYYY-MM-DD HH:mm:ss");

  if (date.year() === moment().year()) {
    return date.format("MM-DD HH:mm:ss");
  }

  return formattedDate;
};

const getExactDate = () => {
  const date = moment.parseZone(props.dateIsoString);
  const formattedDate = date.format("YYYY-MM-DD");
  return formattedDate;
};

const getExactTime = () => {
  const date = moment.parseZone(props.dateIsoString);
  const formattedDate = date.format("HH:mm:ss");
  return formattedDate;
};

const getDateAndTimeFromISOString = () => {
  if (date.value.year() === 1970 || date.value.year() === 1969) {
    return "-";
  }

  // const now = moment().locale(useStore().state.AuthModule.user.language);
  // const threeDaysAgo = now.clone().subtract(5, "days");

  // if (date.isBetween(threeDaysAgo, now)) {
  //   return date.fromNow();
  // }

  // return date.locale(useStore().state.AuthModule.user.language).fromNow();
  if (props.format) {
    return date.value.format(props.format);
  }
  if (date.value.year() === moment().year()) {
    return date.value.format("MM-DD HH:mm:ss");
  }
  return date.value.format("YYYY-MM-DD HH:mm:ss");
};

return (_ctx: any,_cache: any) => {
  return (_ctx.type === 'inFields')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(date.value.format("HH:mm:ss")), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(date.value.format("YYYY-M-D")), 1)
      ]))
    : (_ctx.type === 'withoutSec')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(date.value.format("YYYY-M-D HH:mm")), 1))
      : (_ctx.type === 'GMTinFields')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(getExactTime()), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(getExactDate()), 1)
          ]))
        : (_ctx.type === 'GMToneLiner')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString(getExactDateAndTime()), 1)
            ]))
          : (_ctx.type === 'oneLiner')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(date.value.format("YYYY-M-D HH:mm:ss")), 1))
            : (_ctx.type === 'customCSS')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("span", null, _toDisplayString(date.value.format("YYYY-M-D HH:mm:ss")), 1)
                ]))
              : (_ctx.type === 'customCSSv2')
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("span", null, _toDisplayString(date.value.format("YYYY-M-D")), 1)
                  ]))
                : (_ctx.type === 'eventShop')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("span", null, _toDisplayString(date.value.format("YYYY-M-D")), 1)
                    ]))
                  : (_ctx.type === 'exactTime')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(getExactDateAndTime()) + " GMT", 1))
                    : (_ctx.type === 'reportTime')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(getExactDateAndTime()), 1))
                      : (_ctx.type === 'reportDate')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(getExactDate()), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(getDateAndTimeFromISOString()), 1))
}
}

})